(() => {
  'use strict';
  if (window.__crestReferenceInstalled) return;
  window.__crestReferenceInstalled = true;
  const productId = '6671753805959';
  const variants = {
    '39857214947463': ['Wood', false], '39752109293703': ['Wood', true],
    '39857214980231': ['Black', false], '39752109326471': ['Black', true],
    '40523409260679': ['White', false], '40523409293447': ['White', true],
  };
  const states = new Map();
  const style = document.createElement('style');
  style.textContent = `
    .crest-reference-host{position:relative!important}
    .crest-reference-source{opacity:0!important;pointer-events:none!important}
    [data-crest-cart-media]>.crest-reference-source{position:absolute!important;inset:0;width:100%}
    .crest-reference{margin:0;background:white;color:#222;text-align:center;padding:8px;box-sizing:border-box}
    .crest-reference img{display:block!important;opacity:1!important;visibility:visible!important;width:100%;height:auto;object-fit:contain;max-height:460px}
    .crest-reference figcaption{font:12px/1.4 sans-serif;overflow-wrap:anywhere}
    .crest-reference figcaption p{margin:4px 0}
    .crest-reference-popup>.crest-reference{position:absolute;inset:0;overflow:auto}
    .crest-reference-popup>.crest-reference img{max-height:calc(100% - 110px);height:72%;min-height:80px}
    [data-crest-cart-media]>.crest-reference{padding:0}
    [data-crest-cart-media]>.crest-reference img{height:150px;object-fit:cover}
    .crest-reference-note{font:12px/1.4 sans-serif;overflow-wrap:anywhere;margin-top:8px}
    .crest-reference-note p{margin:4px 0}
  `;
  document.head.append(style);

  function eligible(id, options, owner) {
    const known = variants[id];
    if (owner !== productId || !known) return null;
    let values;
    try { values = JSON.parse(options); } catch { return null; }
    const expected = [known[0], known[1] ? 'Aluminum Topper - Round (Custom Logo)' : 'No Topper (Word Only)', 'Matching body'];
    return Array.isArray(values) && values.length === 3 && values.every((v, i) => v === expected[i]) ? known : null;
  }
  function restore(host) {
    const state = states.get(host);
    if (!state) return;
    state.figure.remove();
    state.note?.remove();
    for (const [node, hidden] of state.originals) {
      node.classList.remove('crest-reference-source');
      if (hidden === null) node.removeAttribute('aria-hidden'); else node.setAttribute('aria-hidden', hidden);
      delete node.dataset.crestOriginalAria;
    }
    host.classList.remove('crest-reference-host', 'crest-reference-popup');
    states.delete(host);
  }
  function show(host, known, word, popup) {
    let state = states.get(host);
    if (!state) {
      // Cached DOM copies may include our old decoration; rebuild it from line data.
      host.querySelectorAll(':scope > .crest-reference').forEach(node => node.remove());
      // Keep provider nodes and its first image in place: its renderer still measures them.
      const originals = [...host.children].filter(n => !n.matches('.crest-reference'));
      state = { originals: new Map(), figure: document.createElement('figure') };
      state.figure.className = 'crest-reference';
      const image = document.createElement('img');
      image.className = 'pplr_original_img';
      image.width = image.height = 679;
      const caption = document.createElement('figcaption');
      for (let i = 0; i < 3; i++) caption.append(document.createElement('p'));
      state.figure.append(image, caption);
      for (const node of originals) {
        const hidden = node.dataset.crestOriginalAria === undefined ? node.getAttribute('aria-hidden') : JSON.parse(node.dataset.crestOriginalAria);
        state.originals.set(node, hidden);
        node.dataset.crestOriginalAria = JSON.stringify(hidden);
        node.classList.add('crest-reference-source');
        node.setAttribute('aria-hidden', 'true');
      }
      host.classList.add('crest-reference-host');
      if (popup) host.classList.add('crest-reference-popup');
      host.append(state.figure);
      states.set(host, state);
    }
    if (state.figure.parentNode !== host) host.append(state.figure);
    // A provider may replace its visual nodes without replacing the surrounding host.
    for (const node of host.children) {
      if (node === state.figure || state.originals.has(node)) continue;
      state.originals.set(node, node.getAttribute('aria-hidden'));
      node.dataset.crestOriginalAria = JSON.stringify(node.getAttribute('aria-hidden'));
      node.classList.add('crest-reference-source');
      node.setAttribute('aria-hidden', 'true');
    }
    const [color, round] = known;
    const src = `https://customize.grryp.com/reference-products/crest/${color.toLowerCase()}-${round ? 'round' : 'word-only'}.png`;
    const image = state.figure.querySelector('img');
    if (image.getAttribute('src') !== src) image.setAttribute('src', src);
    image.alt = `${color} Crest stock hardware example, ${round ? 'blank round topper' : 'no topper'}, sample word LIKEMINDS`;
    const lines = [
      `Stock reference / example: ${color}, ${round ? 'round topper' : 'no topper'}.`,
      'Sample word: LIKEMINDS. This image does not preview your sculpted word or uploaded logo.',
      word ? `Your entered word: ${word}` : 'Your entered word will appear here as text.',
    ];
    const details = !popup && host.closest('tr')?.querySelector('.cart-item__details');
    if (details && !state.note) {
      state.note = details.querySelector('.crest-reference-note') || document.createElement('div');
      state.note.className = 'crest-reference-note';
      if (!state.note.children.length) for (let i = 0; i < 3; i++) state.note.append(document.createElement('p'));
      details.append(state.note);
    }
    if (state.note && state.note.parentNode !== details && details) details.append(state.note);
    const captions = state.figure.querySelectorAll('figcaption p');
    captions.forEach((p, i) => {
      const text = details ? (i === 0 ? 'Stock example' : '') : lines[i];
      if (p.textContent !== text) p.textContent = text;
    });
    state.note?.querySelectorAll('p').forEach((p, i) => { if (p.textContent !== lines[i]) p.textContent = lines[i]; });
  }
  function refresh() {
    const active = new Set();
    document.querySelectorAll('.pplr-modal-box form.pplr_form.pplr_atc_form').forEach(form => {
      const host = form.querySelector('.pplr-p-left');
      if (!host) return;
      const id = form.querySelector('input[name="id"]')?.value;
      const config = [...document.querySelectorAll('[data-crest-config]')].find(c => c.dataset.productId === productId);
      const entry = config && [...config.querySelectorAll('[data-crest-variant]')].find(v => v.dataset.crestVariant === id);
      const known = entry && eligible(id, entry.dataset.options, config.dataset.productId);
      if (known) { active.add(host); show(host, known, form.querySelector('[name="properties[Your Text]"]')?.value || '', true); }
    });
    document.querySelectorAll('[data-crest-cart-media]').forEach(host => {
      const known = eligible(host.dataset.variantId, host.dataset.options, host.dataset.productId);
      if (known && host.dataset.lineKey && host.querySelector('img:not(.pplr_original_img)')) { active.add(host); show(host, known, host.dataset.word || '', false); }
    });
    for (const host of states.keys()) if (!host.isConnected || !active.has(host)) restore(host);
  }
  let pending = false;
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(() => { pending = false; refresh(); }); } };
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['value', 'data-options', 'data-variant-id', 'data-word'],
  });
  document.addEventListener('input', schedule, true);
  document.addEventListener('change', schedule, true);
  document.addEventListener('variant:change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  refresh();
})();
